import { useEffect } from 'react'
import type { UserState } from 'utils/hooks/use-userInfo'
import { monitoring } from 'utils/monitoring/monitoring'

export const useSetUserToThirdParty = (user: UserState) => {
  useEffect(() => {
    if (user.id) {
      monitoring.setUser({ ...user })
    }
  }, [user])
}
